<template>
    <div class="templete">
        <div class="tabs">
            <template v-for="(item,index) in dataTemplate">
                <div style="position: relative;top:-15px; left: -15px;"
                    :class="['item',item.id == target?'checked': '']" class="item" :key="index" @click="choose(item)"
                    v-if="(module.includes(',setting-advanced-tag-custom,') && item.id == 2) || item.id != 2">
                    {{item.name}}</div>
            </template>
        </div>
        <div class="printSetBox clearfix">
            <div class="left">
                <template>
                    <div class="path" style="margin-top:10px;">
                        <span class="title">{{target==2?'捆包号长度字号位置配置':'捆包号长度字号配置'}}</span>
                    </div>
                    <div class="baleSetup">
                        <div class="baleItem">
                            <div class="name">字符长度：</div>
                            <div class="slider">
                                <el-slider @change="sliderChange" show-stops :marks="marksOne" :min="8" :max="16"
                                    v-model="setData.configs.inputs[3].value"></el-slider>
                            </div>
                        </div>
                        <div class="baleItem">
                            <div class="name">字号大小：</div>
                            <div class="slider">
                                <el-slider @change="sliderChange" :marks="marksTwo" :min="36" :max="90"
                                    v-model="setData.configs.inputs[2].value"></el-slider>
                            </div>
                        </div>
                        <div class="baleItem" v-if="target==2">
                            <div class="name">左右位置：</div>
                            <div class="slider">
                                <el-slider @change="sliderChange" :min="0" :max="100" :marks="marksCodeX"
                                    v-model="setData.configs.bale_no[0].value"></el-slider>
                            </div>
                        </div>
                        <div class="baleItem" v-if="target==2">
                            <div class="name">上下位置：</div>
                            <div class="slider">
                                <el-slider @change="sliderChange" :min="0" :max="100" :marks="marksCodeY"
                                    v-model="setData.configs.bale_no[1].value"></el-slider>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="path">
                    <span class="title">{{target==2?'其他模版自定义配置':'标签字段自定义配置（北美材）'}}</span>
                </div>
                <div class="group">
                    <template v-for="(item) in setData.configs.fields">
                        <div :class="['item', item.show ? 'checked': '' ]" :key="item.key"
                            v-if="item.key == 'qr_code' || (target==2 && item.key == 'bale_no')" @click="check(item,1)">
                            {{ item.name }}
                        </div>
                    </template>
                </div>
                <div class="path" style="margin-top:20px;" v-if="target == 1">
                    <span class="title"></span>
                </div>
                <div class="group" v-if="target == 1">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.hidden_show"
                        :key="item.key" @click="check(item,8)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;" v-if="target != 1 && target != 2">
                    <span class="title"></span>
                </div>
                <div class="group" v-if="target != 1">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.select_breed"
                        :key="item.key" @click="check(item,5)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;" v-if="target != 2">
                    <span class="title"></span>
                </div>
                <div class="group">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.select_grade"
                        :key="item.key" @click="check(item,6)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;" v-if="target == 1">
                    <span class="title"></span>
                </div>
                <div class="group" v-if="target == 1">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.cube"
                        :key="item.key" @click="check(item,7)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;" v-if="target != 2">
                    <span class="title"></span>
                </div>
                <div class="group">
                    <template v-for="(item) in setData.configs.brand">
                        <div :class="['item', item.show ? 'checked': '' ]"
                            v-if="!(target ==1 && item.field == 'pieces')" :key="item.key" @click="check(item,2)">
                            {{ item.name }}
                        </div>
                    </template>
                </div>
                <div class="path" style="margin-top:20px;" v-if="target!=2">
                    <span class="title"></span>
                </div>
                <div class="group" v-if="target!=2">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.numbers"
                        :key="item.key" @click="check(item,4)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="path" style="margin-top:20px;" v-if="target!=2">
                    <span class="title"></span>
                </div>
                <div class="group" v-if="target!=2">
                    <div :class="['item', item.show ? 'checked': '' ]" v-for="(item) in setData.configs.company"
                        :key="item.key" @click="check(item,3)">
                        {{ item.name }}
                    </div>
                </div>
                <div class="printNumberBox clearfix" v-if="target==2">
                    <div class="printNumberTitle">二维码大小：</div>
                    <el-input class="printNUmberInp" @change="setLabel"
                        v-model.number="setData.configs.qrcode[6].value" />
                </div>
                <div class="path" style="margin-top:10px;" v-if="target==2">
                    <div class="printNumberTitle">二维码位置：</div>
                </div>
                <div class="baleSetup" v-if="target==2">
                    <div class="baleItem">
                        <div class="">x轴：</div>
                        <div class="slider">
                            <el-slider @change="sliderChange" :min="0" :max="100" :marks="marksCodeX"
                                v-model="setData.configs.qrcode[4].value"></el-slider>
                        </div>
                    </div>
                    <div class="baleItem">
                        <div class="">y轴：</div>
                        <div class="slider">
                            <el-slider @change="sliderChange" :min="0" :max="100" :marks="marksCodeY"
                                v-model="setData.configs.qrcode[5].value"></el-slider>
                        </div>
                    </div>
                </div>

                <template v-if="target == 2">
                    <div class="path" style="margin-top:10px;">
                        <span class="title">其他模版纸张大小配置</span>
                    </div>
                    <div class="baleSetup">
                        <div class="baleItem itemWh">
                            <span class="name">纸张宽度 (cm)：</span>
                            <el-input class="input" size="mini" placeholder="宽度" @change="setLabel"
                                v-model.number="setData.configs.qrcode[2].value"></el-input>
                        </div>
                        <div class=" baleItem itemWh">
                            <span class="name">纸张高度 (cm)：</span>
                            <el-input class="input" size="mini" placeholder="高度" @change="setLabel"
                                v-model.number="setData.configs.qrcode[3].value"></el-input>
                        </div>
                    </div>
                    <div class="baleSetup">
                        <crop style="height: 246px;" @upDataImage="upDataImage"></crop>
                        <div class="baleImgList">
                            <span class="imgListSpan" v-for="(item,ind) in setData.configs.qrcode[1].value">
                                <el-image class="imgBack"
                                    :class="item == setData.configs.qrcode[0].value?'imgBackCheck':''" :key="ind"
                                    @click="checkImage(item)" :src="item">
                                </el-image>
                                <div class="deleteBtn" @click="deleteImg(item,ind)">
                                    <span class="imgDelete"></span>
                                </div>
                            </span>
                        </div>
                    </div>
                </template>

                <div class="printNumberBox clearfix">
                    <div class="printNumberTitle">打印次数：</div>
                    <el-input class="printNUmberInp" @change="setLabel"
                        v-model.number="setData.configs.print_number[0].value" />
                </div>
                <div class="path companyDefinition" style="margin-top:20px;" v-if="target!=2">
                    <span class="title">
                        公司名称自定义
                        <span class="explain">(添加自定义模板)</span>
                        <span class="add_icon" @click="addCompany"></span>
                    </span>
                    <el-input class="companyName" :class="setData.configs.inputs[0].status ==1?'companyNameChecked':''"
                        placeholder="请输入公司名称" v-model="setData.configs.inputs[0].value" @input="changeComName"
                        @blur="setLabel"></el-input>
                </div>

                <div class="companySet" style="margin-top:20px;">
                    <div class="pathItme" :class="item.status==1?'pathItmeChecked':''"
                        v-for="(item,ind) in setData.configs.company_infos" :key="ind" @click="checkCompany(item,ind)">
                        <div class="listItem">
                            <span class="name">公司名称：</span>
                            <el-input class="companyInput" @click.stop.native @blur="setLabel" v-model="item.name"
                                placeholder="公司名称"></el-input>
                        </div>
                        <div class="listItem">
                            <span class="name">公司地址：</span>
                            <el-input class="companyInput" @click.stop.native @blur="setLabel" v-model="item.address"
                                placeholder="公司地址"></el-input>
                        </div>
                        <div class="listItem">
                            <span class="name">联系电话：</span>
                            <el-input class="companyInput" @click.stop.native @blur="setLabel" v-model="item.phone"
                                placeholder="联系电话"></el-input>
                        </div>
                        <div class="listItem">
                            <span class="name">LOGO：</span>
                            <div class=" companyInputLogo" @click.stop>
                                <el-upload class="uploadCompany" ref='upload_path' drag :show-file-list="false"
                                    :action="oss.host" :data="upload_data" :on-success="handleSuccess"
                                    :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                                    <div class="uploadDiv" @click="uploadParams(item,ind)">
                                        <el-image v-if="item.logo!=''" :src="item.logo" fit="cover"
                                            class="uploadImage"></el-image>
                                        <img v-else src="/icon/plus-default@2x.png" class="uploadImageAdd" />
                                    </div>
                                </el-upload>
                                <div v-if="item.logo!=''" class="deleteIcon" @click="deleteLogo(item,ind)"><i
                                        class="el-icon-close"></i></div>
                            </div>
                        </div>
                        <div class="listItem">
                            <span class="name">微信二维码：</span>
                            <div class="companyInputLogo" @click.stop>
                                <el-upload class="uploadCompany" ref='upload_qrcode_path' drag :show-file-list="false"
                                    :action="oss.host" :data="upload_data" :on-success="handleQrcodeSuccess"
                                    :before-upload="beforeQrcodeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                                    <div class="uploadDiv" @click="uploadUserQrcodeParams(item,ind)">
                                        <el-image v-if="item.qr_code!=''" :src="item.qr_code" fit="cover"
                                            class="uploadImage">
                                        </el-image>
                                        <img v-else src="/icon/plus-default@2x.png" class="uploadImageAdd" />
                                    </div>
                                </el-upload>
                                <div v-if="item.qr_code!=''" class="deleteIcon" @click="deleteQrcode(item,ind)"><i
                                        class="el-icon-close"></i></div>
                                <span class="del_icon" @click.stop="deleteCompany(ind)"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="path">
                    <span class="title">配置预览</span>
                </div>
                <div class="rightBox printTipBoxAmerica">
                    <div class="labelBox" :style="{
                            'width': target==2? `${setData.configs.qrcode[2].value*0.95}cm`:'',
                            'height':target==2? `${setData.configs.qrcode[3].value*0.95}cm`:'',
                        }">
                        <div class="label_baleNo" v-if="target == 0">
                            <span class="label_baleNoT"
                                :style="{fontSize:setData.configs.inputs[2].value+'px'}">{{printData.bale_no}}</span>
                            <img v-if="printData.company_logo!=''&&printData.config.includes(',company_logo,')"
                                :src="printData.company_logo" class="label_logo" />
                        </div>
                        <!-- 默认材种 -->
                        <div class="labelMessBox clearfix" v-if="target == 0">
                            <div class="labelMess widLeft" v-if="printData.config.includes(',breed_breed,')">
                                <div class="labelMessKey">Species:</div>
                                <div class="labelMessValue">{{printData.breed}}</div>
                            </div>
                            <div class="labelMess widLeft" v-if="printData.config.includes(',breed_attribute,')">
                                <div class="labelMessKey">Species:</div>
                                <div class="labelMessValue">{{printData.attribute}}</div>
                            </div>
                            <div class="labelMess widRight" v-if="printData.config.includes(',original_thickness,')">
                                <div class="labelMessKey">Thickness:</div>
                                <div class="labelMessValue">{{printData.original_thickness}}</div>
                            </div>
                            <div class="labelMess widLeft" v-if="printData.config.includes(',grade_grade,')">
                                <div class="labelMessKey">Grade:</div>
                                <div class="labelMessValue">{{printData.grade}}</div>
                            </div>
                            <div class="labelMess widLeft" v-if="printData.config.includes(',grade_code,')">
                                <div class="labelMessKey">Grade:</div>
                                <div class="labelMessValue">{{printData.code}}</div>
                            </div>

                            <div class="labelMess widRight" v-if="printData.config.includes(',original_length,')">
                                <div class="labelMessKey">Length:</div>
                                <div class="labelMessValue">{{printData.original_length}}</div>
                            </div>

                            <div class="labelMess widLeft">
                                <div v-if="printData.config.includes(',brand,')">
                                    <div class="labelMessKey">Brand:</div>
                                    <div class="labelMessValue">{{printData.brand}}</div>
                                </div>
                                <div v-else-if="printData.config.includes(',supplier,')">
                                    <div class="labelMessKey">Supplier:</div>
                                    <div class="labelMessValue">{{printData.supplier}}</div>
                                </div>
                                <div v-else-if="printData.config.includes(',pieces,')">
                                    <div class="labelMessKey">Pieces:</div>
                                    <div class="labelMessValue">{{printData.pieces}}</div>
                                </div>
                            </div>
                            <div class="labelMess widRight">
                                <div v-if="printData.config.includes(',contract_no,')">
                                    <div class="labelMessKey">Contract No:</div>
                                    <div class="labelMessValueBlock">{{printData.contract_no}}</div>
                                </div>
                                <div v-else-if="printData.config.includes(',original_bale,')">
                                    <div class="labelMessKey">Batch No:</div>
                                    <div class="labelMessValueBlock">{{printData.original_bale}}</div>
                                </div>
                                <div v-else-if="printData.config.includes(',container_no,')">
                                    <div class="labelMessKey">Container No:</div>
                                    <div class="labelMessValueBlock">{{printData.container_no}}</div>
                                </div>
                            </div>

                            <img :src="printData.qr_code" v-if="printData.config.includes(',qr_code,')"
                                class="labelQrCode" />
                        </div>

                        <!-- 欧洲材 -->
                        <div class="label_baleNo" v-if="target == 1">
                            <span class="label_baleNoT"
                                :style="{fontSize:setData.configs.inputs[2].value+'px'}">{{printData.bale_no}}</span>
                            <img v-if="printData.company_logo!=''&&printData.config.includes(',company_logo,')"
                                :src="printData.company_logo" class="label_logo" />
                        </div>
                        <div class="labelMessBox clearfix europe" v-if="target == 1">
                            <div class="europeContent">
                                <div class="item itemLeft" v-if="printData.config.includes(',breed,')">
                                    <div class="labelMessKey">Species:</div>
                                    <div class="labelMessValue">{{printData.breed}}</div>
                                </div>
                                <div class="item itemMidden" v-if="printData.config.includes(',attribute,')">
                                    <div class="labelMessKey">Attribute:</div>
                                    <div class="labelMessValue">{{printData.attribute}}</div>
                                </div>
                                <div class="item itemRight">
                                    <div class="labelMessKey">Thickness:</div>
                                    <div class="labelMessValue">{{printData.original_thickness}}</div>
                                </div>
                            </div>
                            <div class="europeContent">
                                <div class="item itemLeft" v-if="printData.config.includes(',grade_grade,')">
                                    <div class="labelMessKey">Grade:</div>
                                    <div class="labelMessValue">{{printData.grade}}</div>
                                </div>
                                <div class="item itemLeft" v-if="printData.config.includes(',grade_code,')">
                                    <div class="labelMessKey">Grade:</div>
                                    <div class="labelMessValue">{{printData.code}}</div>
                                </div>
                                <div class="item itemMidden">
                                    <div class="labelMessKey">Length:</div>
                                    <div class="labelMessValue">{{printData.original_length}}</div>
                                </div>
                                <div class="item itemRight" v-if="printData.config.includes(',sales_cube,')">
                                    <div class="labelMessKey">Cube:</div>
                                    <div class="labelMessValue">{{printData.sales_cube}}</div>
                                </div>
                                <div class="item itemRight" v-if="printData.config.includes(',original_cube,')">
                                    <div class="labelMessKey">Cube:</div>
                                    <div class="labelMessValue">{{printData.original_cube}}</div>
                                </div>
                            </div>
                            <div class="europeContent">
                                <div class="item itemLeft" v-if="printData.config.includes(',brand,')">
                                    <div class="labelMessKey">Brand:</div>
                                    <div class="labelMessValue">{{printData.brand}}</div>
                                </div>
                                <div class="item itemLeft" v-if="printData.config.includes(',supplier,')">
                                    <div class="labelMessKey">Supplier:</div>
                                    <div class="labelMessValue">{{printData.supplier}}</div>
                                </div>
                                <div class="item itemMidden" v-if="printData.config.includes(',pieces,')">
                                    <div class="labelMessKey">Pieces:</div>
                                    <div class="labelMessValue">{{printData.pieces}}</div>
                                </div>
                                <div class="item itemRight bundleNo" v-if="printData.config.includes(',contract_no,')">
                                    <div class="labelMessKey">Contract No:</div>
                                    <div class="labelMessValue">{{printData.contract_no}}</div>
                                </div>
                                <div class="item itemRight bundleNo"
                                    v-if="printData.config.includes(',original_bale,')">
                                    <div class="labelMessKey">Batch No:</div>
                                    <div class="labelMessValue">{{printData.original_bale}}</div>
                                </div>
                                <div class="item itemRight bundleNo" v-if="printData.config.includes(',container_no,')">
                                    <div class="labelMessKey">Container No:</div>
                                    <div class="labelMessValue">{{printData.container_no}}</div>
                                </div>
                            </div>

                            <img :src="printData.qr_code" v-if="printData.config.includes(',qr_code,')"
                                class="labelQrCode" />
                        </div>

                        <div class="labelMessBox clearfix hsLabelBox" v-if="target == 2">
                            <span v-if="printData.config.includes(',bale_no,')" class="hs_label_baleNoT" :style="{
                                fontSize:setData.configs.inputs[2].value+'px',
                                'left':`${this.setData.configs.bale_no[0].value}%`,
                                'top':`${this.setData.configs.bale_no[1].value}%`

                            }">{{printData.bale_no}}</span>
                            <div class="hsBoxBack" :style="{
                                'width':qrCodeLeftStyle,
                                'height':qrCodeBottomStyle
                            }">
                                <img :src="printData.qr_code" v-if="printData.config.includes(',qr_code,')" :style="{
                                    'width': `${setData.configs.qrcode[6].value}px`,
                                    'height': `${setData.configs.qrcode[6].value}px`,
                                    'left': `${this.setData.configs.qrcode[4].value}%`,
                                    'top': `${this.setData.configs.qrcode[5].value}%`,
                                }" class="labelQrCodeHs" />
                            </div>
                            <img class="hsImage" :src="printData.background_tag" alt="">
                        </div>
                        <div class="labelCompanyBox" v-if="target != 2">
                            <div class="leftView" v-if="printData.config.indexOf(',company_qr_code,')!=-1">
                                <img :src="printData.company_qr_code" class="userQrcode" alt="">
                            </div>
                            <div class="rightView">
                                <div class="labelCompany" v-if="printData.config.includes(',company_name,')">
                                    {{printData.company_name}}</div>
                                <div class="labelCompanyMess"><span
                                        v-if="printData.config.indexOf(',company_address,')!=-1">地址：{{printData.company_address}}</span>
                                    <span
                                        v-if="printData.config.indexOf(',company_mobile,')!=-1">电话：{{printData.company_mobile}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
    .tableBox {
        display: block;
    }

    /* // width:14.25cm;height:9.5cm; */
    .printTipBoxAmerica .printTemplate {
        width: 14.25cm;
        height: 9.5cm;
        box-sizing: border-box;
        overflow: hidden;
        margin: auto;
        position: relative;
        color: #000;
        page-break-after: always;
    }

    .printTipBoxAmerica .labelBox {
        background-color: #fff;
        border: 1px solid #000;
        display: block;
        width: 14.25cm;
        height: 9.4cm;
        box-sizing: border-box;
        overflow: hidden;
        margin: auto;
        page-break-after: always;
    }

    .printTipBoxAmerica .label_baleNo {
        height: 130px;
        font-size: 98px;
        font-weight: 600;
        text-align: center;
        border-bottom: 1px solid #000;
        position: relative;
        line-height: 130px;
    }

    .printTipBoxAmerica .label_baleNoT {
        position: absolute;
        z-index: 1;
        left: 84px;
        text-align: center;
        display: inline-block;
        width: 453px;
    }

    .printTipBoxAmerica .labelMessBox {
        padding: 7px 128px 45px 3px;
        position: relative;
        border-bottom: 1px solid #000;
        height: 175px;
        box-sizing: border-box;
    }

    .printTipBoxAmerica .hsLabelBox {
        border: 0;
        position: relative;
        width: 100%;
        height: 100%;
        padding: 1px;

        .labelQrCodeHs {
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 100;
        }

        .hsBoxBack {
            position: relative;
            z-index: 30;
        }

        .hs_label_baleNoT {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 32;
        }

        .hsImage {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 20;
        }
    }

    .printTipBoxAmerica .labelMess {
        float: left;
        text-align: left;
        margin-bottom: 5px;
        width: 50%;
        height: 50px;
    }

    .printTipBoxAmerica .labelMess:nth-child(2n) {
        float: right;
    }

    .printTipBoxAmerica .labelMessBox .labelMess.widLeft {
        width: 57%;
    }

    .printTipBoxAmerica .labelMessBox .labelMess.widRight {
        width: 43%;
    }

    /* // 欧洲材 */
    .printTipBoxAmerica .europe .europeContent {
        display: flex;
    }

    .printTipBoxAmerica .europe .europeContent .item {
        text-align: left;
        width: 33%;
        float: left;
        padding: 0 0 0 10px;
    }

    .printTipBoxAmerica .europe .europeContent .item:nth-child(1) {
        width: 35%;
    }

    .printTipBoxAmerica .europe .europeContent .item:nth-child(2) {
        width: 32%;
    }

    .printTipBoxAmerica .europe .europeContent .item:nth-child(3) {
        width: 30%;
    }

    .printTipBoxAmerica .europe .europeContent .bundleNo .labelMessValue {
        white-space: nowrap;
    }


    .printTipBoxAmerica .labelBottomBox {
        width: 100%;
        height: 40px;
        position: absolute;
        display: flex;
        bottom: 0;
        text-align: left;
    }

    .printTipBoxAmerica .labelBottomBox .labelBottomItemLeft {
        width: 45%;
    }

    .printTipBoxAmerica .labelBottomBox .labelBottomItemRight {
        width: 55%;
    }

    .printTipBoxAmerica .labelMessKey {
        display: inline;
        font-size: 12px;
    }

    .printTipBoxAmerica .labelMessValue {
        font-size: 31px;
        font-weight: 600;
        line-height: 30px;
        word-break: break-all;
        margin-left: 6px;
    }

    .printTipBoxAmerica .labelMessValueBlock {
        width: 100%;
        font-size: 31px;
        line-height: 30px;
        font-weight: 600;
    }

    .printTipBoxAmerica .labelMessLong {
        width: 100%;
        text-align: left;
        float: left;
    }

    .printTipBoxAmerica .labelMessValueLong {
        display: inline;
        font-size: 25px;
        font-weight: 600;
    }

    .printTipBoxAmerica .labelQrCode {
        width: 125px;
        height: 125px;
        position: absolute;
        top: 3px;
        right: 3px;
    }

    .printTipBoxAmerica .labelCompanyBox {
        text-align: center;
        padding-top: 3px;
        height: 47px;
        display: flex;
        flex-direction: row;

        .leftView {
            height: 42px;
            flex-basis: 56px;

            .userQrcode {
                width: 42px;
                height: 42px;
            }
        }

        .rightView {
            flex: 1;
        }
    }

    .printTipBoxAmerica .labelCompany {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 5px;
    }

    .printTipBoxAmerica .labelCompanyMess {
        font-size: 12px;
    }

    .printTipBoxAmerica .labelCompanyMess span {
        margin-right: 10px;
    }

    .printTipBoxAmerica .label_logo {
        width: 75px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 10px;
        margin: auto;
        z-index: 0;
    }


    .printNumberBox {
        margin-top: 20px;
    }

    .printNumberTitle {
        font-size: 14px;
        float: left;
        height: 30px;
        line-height: 30px;
    }

    .printNUmberInp {
        width: 100px;
        float: left;
    }


    .printSetBox .companyName {
        width: 350px;
        margin-top: 10px;
    }

    .printSetBox .companyNameChecked:after {
        display: block;
        content: "";
        width: 21px;
        height: 21px;
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 1;
        background: url(/icon/checkeded.png) no-repeat;
        background-size: cover;
    }

    .printSetBox .companyName /deep/ .el-input__inner {
        height: 35px;
    }

    .printSetBox .companyName /deep/ .el-input__inner:focus {
        border-color: #b21111;
    }

    .companySet {
        display: block;

        .pathItme {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            position: relative;
            background: #f2f2f2;
            margin-bottom: 10px;
            padding: 10px 0 0 10px;
            border-radius: 4px;
            cursor: pointer;

            .listItem {
                display: flex;
                align-items: center;
                margin-right: 10px;
                margin-bottom: 10px;
                width: 220px;

                .name {
                    flex-basis: 100px;
                    white-space: nowrap;
                    overflow: hidden;
                    font-size: 14px;
                    text-align: right;
                }

                .companyInput {
                    flex: 1;
                    min-width: 120px;
                    text-align: left;
                }

                .companyInputLogo {
                    position: relative;
                    width: 45px;
                    height: 30px;
                    display: inline-block;
                }

                .companyInputLogo:hover .deleteIcon {
                    display: flex;
                }

                .companyInput /deep/ .el-input__inner:focus {
                    border-color: #b21111;
                }

                .companyInput /deep/ .el-input__inner {
                    height: 32px;
                    width: 120px;
                }

                .uploadCompany /deep/ .el-upload-dragger {
                    width: 45px;
                    height: 30px;
                    border-radius: 4px;
                    border: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .uploadCompany .uploadDiv {
                    height: 100%;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                }

                .uploadCompany .uploadImage {
                    width: 100%;
                    height: 100%;
                }

                .uploadCompany .uploadImageAdd {
                    width: 12px;
                    height: 12px;
                }

                .deleteIcon {
                    position: absolute;
                    top: 0;
                    right: 0;
                    z-index: 10;
                    width: 45px;
                    height: 30px;
                    background: #B21111;
                    opacity: 0.7;
                    border-radius: 4px;
                    display: none;
                    justify-content: center;
                    align-items: center;
                    color: #fff;
                }

                .deleteIcon>i {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 15px;
                    height: 15px;
                    border-radius: 50%;
                    background: #fff;
                    color: #B21111;
                    font-size: 12px;
                }
            }

            .del_icon {
                position: absolute;
                right: -36px;
                top: 5px;
                display: inline-block;
                width: 20px;
                height: 20px;
                background: url(/icon/frame_minus.png) center center no-repeat;
                background-size: 16px 16px;
                cursor: pointer;
            }
        }

        .pathItmeChecked:after {
            display: block;
            content: "";
            width: 21px;
            height: 21px;
            position: absolute;
            right: 0;
            bottom: 0;
            z-index: 1;
            background: url(/icon/checkeded.png) no-repeat;
            background-size: cover;
        }
    }

    .baleSetup {
        margin-bottom: 30px;

        .baleItem {
            padding: 2px 0;
            margin-bottom: 10px;
            display: flex;
            align-items: center;

            .name {
                flex-basis: 130px;
            }

            .slider {
                width: 220px;
                padding: 0 15px;
            }

            .slider /deep/ .el-slider__bar {
                background-color: #B21111;
            }

            .slider /deep/ .el-slider__button {
                border-color: #B21111;
            }
        }

        .itemWh {
            .input {
                width: 140px;
            }
        }
    }

    .baleImgList {
        margin-top: 10px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .baleImgList .imgBack {
        width: 60px;
        height: 40px;
        border: 1px solid #b21111;
        margin-right: 10px;
        margin-bottom: 5px;
        cursor: pointer;
        border-radius: 3px;
    }

    .baleImgList .imgBackCheck {
        position: relative;
    }

    .baleImgList .imgBackCheck::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 10;
        width: 21px;
        height: 21px;
        background: url(/icon/checkeded.png) no-repeat;
        background-size: cover;
    }

    .imgListSpan {
        position: relative;
    }

    .imgListSpan:hover .deleteBtn {
        display: flex;
    }

    .deleteBtn {
        position: absolute;
        right: 10px;
        bottom: 10px;
        z-index: 20;
        background: rgba(0, 0, 0, 0.6);
        width: 23px;
        height: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        cursor: pointer;
        display: none;
    }

    .imgDelete {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url(/icon/delete-suspension@2x.png) no-repeat;
        background-size: cover;
    }

    .path {
        margin-bottom: 7px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            border-left: 4px solid #b21111;
            padding-left: 12px;
            position: relative;
        }

        .add_icon {
            position: absolute;
            right: -36px;
            top: 1px;
            display: inline-block;
            width: 20px;
            height: 20px;
            background: url(/icon/frame_plus.png) center center no-repeat;
            background-size: 16px 16px;
            cursor: pointer;
        }
    }

    .companyDefinition {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        .explain {
            font-size: 12px;
            color: #B21111;
        }
    }

    .table_path {
        flex: 1;
        box-shadow: 0px 0px 10px rgba(94, 94, 94, 0.16);
        border-radius: 3px;
        width: 100%;
    }

    .el-icon-refresh {
        margin-right: 10px;
        cursor: pointer;
        color: #F9A602;
        font-weight: 600;
    }

    .tab {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: rgba(51, 51, 51, 1);

        .item {
            border-bottom: 3px solid transparent;
            padding: 4px;
            cursor: pointer;

            &.active {
                border-color: #B21111
            }
        }

        .item+.item {
            margin-left: 75px
        }
    }

    .group {
        display: flex;
        flex-wrap: wrap;

        .item {
            min-width: 85px;
            height: 36px;
            line-height: 32px;
            text-align: center;
            padding: 0 12px;
            border-radius: 3px;
            border: 1px solid rgba(102, 102, 102, 1);
            cursor: pointer;
            margin: 6px;
        }

        .item.checked {
            border: 1px solid rgba(178, 17, 17, 1);
            position: relative;
            color: #B21111;

            &::after {
                display: block;
                content: "";
                width: 21px;
                height: 21px;
                position: absolute;
                right: 0;
                bottom: 0;
                background: url("/icon/checkeded.png") no-repeat;
                background-size: cover;
            }
        }

        .check_all_item {
            height: 36px;
            line-height: 36px;
            text-align: center;
            margin: 6px;
        }
    }

    .flex_1 {
        flex: 1;
    }

    .printSetBox {
        padding-right: 15.25cm;
        box-sizing: border-box;
        position: relative;
    }

    .blue {
        color: rgb(21, 91, 212);
        cursor: pointer;
    }

    /* // .left{} */
    .rightBox {
        padding: 20px;
        box-sizing: border-box;
        background-color: F6F7FB;
    }

    .right {
        margin-left: 1cm;
        position: absolute;
        top: 0;
        right: 0;
    }

    /* // F6F7FB */


    .tabs {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .item {
            min-width: 85px;
            font-size: 14px;
            padding: 5px 15px;
            text-align: center;
            border-radius: 3px;
            border: 1px solid rgba(102, 102, 102, 1);
            cursor: pointer;
            margin: 6px 6px 6px 0;
        }

        .item.checked {
            border: 1px solid rgba(178, 17, 17, 1);
            position: relative;
            color: #B21111;

            &::after {
                display: block;
                content: "";
                width: 21px;
                height: 21px;
                position: absolute;
                right: 0;
                bottom: 0;
                background: url("/icon/checkeded.png") no-repeat;
                background-size: cover;
            }
        }

        .item+.item {
            margin-left: 25px;
        }
    }
</style>
<script>
    import crop from "./cropper"
    export default {
        components: {
            crop
        },
        data() {
            return {
                module: localStorage.dw_erp_power_code,
                dataTemplate: [
                    { name: '默认', id: 0, isChecked: false },
                    { name: '欧洲材', id: 1, isChecked: false },
                    { name: '其他模版', id: 2, isChecked: false },
                ],
                target: 0,
                setData: {
                    tpl: '',
                    category: 1,
                    configs: {
                        fields: [],
                        brand: [],
                        company: [],
                        numbers: [],
                        select_breed: [],
                        select_grade: [],
                        inputs: [
                            { key: "title", name: "", show: true, sort: 0, value: localStorage.dw_erp_company_name },
                            { key: "background", name: "", show: true, sort: 1, value: '' },
                            { key: "bale_size", name: "捆包字号", show: true, sort: 2, value: 8 },
                            { key: "bale_length", name: "捆包位数", show: true, sort: 3, value: 90 },
                        ],
                        print_number: [
                            {
                                key: "print_number",
                                name: "打印次数",
                                value: 0,
                                show: true
                            }
                        ],
                        qrcode: [
                            { key: "background_tag", name: "标签图片", show: true, sort: 0, value: '' },
                            { key: "tag_history", name: "标签历史", show: true, sort: 1, value: [] },
                            { key: "tag_width", name: "标签宽度", show: true, sort: 2, value: '' },
                            { key: "tag_height", name: "标签高度", show: true, sort: 3, value: '' },
                            { key: "qrcode_x", name: "二维码左右", show: true, sort: 4, value: 1 },
                            { key: "qrcode_y", name: "二维码上下", show: true, sort: 5, value: 1 },
                            { key: "qrcode_size", name: "二维码大小", show: true, sort: 6, value: '' },
                        ],
                        bale_no: [
                            { key: "bale_x", name: "捆包号左右", show: true, sort: 1, value: 1 },
                            { key: "bale_y", name: "捆包号上下", show: true, sort: 2, value: 1 },
                        ],
                        company_infos: []
                    }
                },
                detailConfig: [],
                printData: {
                    bale_no: "kb888888",
                    grade: "1COM",
                    attribute: "毛边",
                    code: "code",
                    original_cube: "3.6665",
                    sales_cube: "3.8888",
                    breed: "橡木",
                    brand: "TWP",
                    original_thickness: "4/4",
                    original_length: "9-10",
                    supplier: "谱木科技",
                    company_name: localStorage.dw_erp_company_name,
                    company_address: "江苏省太仓市龙江路387号(2号仓库)",
                    company_mobile: "13888888888",
                    company_logo: "/icon/logo2.png",
                    qr_code: "/icon/code.png",
                    company_qr_code: '/icon/code.png',
                    // thk:"11-11-11",
                    contract_no: "2020202020",
                    batch_no: "TF727324",
                    container_no: "HG832424",
                    original_bale: "GD888888",
                    pieces: "11",
                    config: "",
                    background_tag: "https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/yingmu_wechat/white.png",
                    tag_history: []
                },
                printNumber: 0,

                marksOne: {
                    8: "8个字符",
                    16: "16",
                },
                marksTwo: {
                    36: "36像素",
                    90: "90",
                },
                marksCodeX: {
                    1: "左",
                    100: "右",
                },
                marksCodeY: {
                    1: "上",
                    100: "下",
                },

                upload_data: {},
                oss: {
                    host: "",
                },
                companyParams: {},
                companyNum: '',
            }
        },
        computed: {
            qrCodeLeftStyle() {
                return `calc(100% - ${this.setData.configs.qrcode[6].value}px)`;
            },
            qrCodeBottomStyle() {
                return `calc(100% - ${this.setData.configs.qrcode[6].value}px)`;
            },
        },
        watch: {
            setData: {
                deep: true,
                handler(a, b) {
                    if (a.configs.inputs[3]) {
                        let text = "kb88888888888888";
                        this.printData.bale_no = text.substring(0, a.configs.inputs[3].value);
                    }
                }
            }
        },
        created() {
            this.getTag();
        },
        methods: {
            getTag(name) {
                this.postFunc('/erp/print.tag.default.tpl', {}, res => {
                    this.target = res.data.data.template_id && res.data.data.template_id[2] ? res.data.data.template_id[2] : 0;
                    this.getList();
                })
                // if(name == 'upData'){
                //     this.getList('upData');
                // }else{
                // }
            },
            getList(name) {
                // let {target} = this.$data; 
                this.postFunc("/erp/print.set.tag.get", { category: 1, tpl: this.target }, res => {
                    this.setData.configs.fields = res.data.data.fields;
                    this.setData.configs.company = res.data.data.company;
                    this.setData.configs.numbers = res.data.data.numbers;

                    var select_breed = res.data.data.select_breed;
                    var brand = res.data.data.brand;
                    // if(target == 1){
                    //     let selectBreedArr = JSON.parse(JSON.stringify(res.data.data.select_breed));
                    //     selectBreedArr.forEach(each=>{
                    //         each.show = false;
                    //     })
                    //     select_breed = selectBreedArr;

                    //     let brandArr = JSON.parse(JSON.stringify(res.data.data.brand));
                    //     brandArr.forEach(each=>{
                    //         if(each.key == 'pieces'){
                    //             each.show = false;
                    //         }
                    //     })
                    //     brand = brandArr;
                    // }
                    this.setData.configs.select_breed = select_breed;
                    this.setData.configs.brand = brand;

                    this.setData.configs.cube = res.data.data.cube;
                    this.setData.configs.hidden_show = res.data.data.hidden_show;

                    this.setData.configs.select_grade = res.data.data.select_grade;
                    this.setData.configs.print_number = res.data.data.print_number;

                    res.data.data.qrcode.forEach(item => {
                        if (item.key == 'qrcode_x' || item.key == 'qrcode_y') {
                            item.value = item.value == '' ? 1 : item.value;
                        }
                    })
                    res.data.data.bale_no.forEach(item => {
                        if (item.key == 'bale_x' || item.key == 'bale_y') {
                            item.value = item.value == '' || item.value == '0' ? 1 : item.value;
                        }
                    })

                    this.setData.configs.qrcode = res.data.data.qrcode;
                    this.setData.configs.bale_no = res.data.data.bale_no;

                    this.printNumber = res.data.data.print_number[0].value;
                    if (res.data.data.inputs) {
                        this.setData.configs.inputs = res.data.data.inputs;
                        this.printData.company_name = res.data.data.inputs[0].value;
                    }
                    this.setData.configs.company_infos = res.data.data.company_infos;
                    // 渲染公司自定义
                    if (res.data.data.company_infos && res.data.data.company_infos.length > 0) {
                        this.printData.company_name = res.data.data.inputs[0].value;
                        this.printData.company_address = "江苏省太仓市龙江路387号(2号仓库)";
                        this.printData.company_mobile = '13888888888';
                        this.printData.company_logo = "/icon/logo2.png";
                        this.printData.company_qr_code = "/icon/code.png";
                        res.data.data.company_infos.forEach(em => {
                            if (em.status == 1) {
                                this.printData.company_name = em.name;
                                this.printData.company_address = em.address;
                                this.printData.company_mobile = em.phone;
                                this.printData.company_logo = em.logo;
                                this.printData.company_qr_code = em.qr_code;
                            }
                        })
                    }

                    this.printData.config = "," + (res.data.data.configs.join(",")).toString() + ",";
                    this.setData.tpl = this.target;
                    if (res.data.data.tpl != this.target) {
                        if (name == 'upData') {
                            this.setNoUploadLabel();
                        } else {
                            this.target = res.data.data.tpl;
                        }
                    }
                }, error => {
                    this.tip(error.data.message, "warning");
                })
            },
            choose(row) {
                this.target = row.id;
                this.setData.tpl = row.id;
                this.getList('upData');
            },
            check(item, type) {
                let arr = ['fields', 'brand', 'company', 'numbers', 'select_breed', 'select_grade', 'cube', 'hidden_show'];
                let selectType = false;
                let selectFlag = false;
                // if(type==1){
                //     return;
                // }
                arr[type - 1] == "brand" || arr[type - 1] == "cube" || arr[type - 1] == "numbers" || arr[type - 1] == "select_breed" || arr[type - 1] == "select_grade" ? selectType = true : selectType = false;
                arr[type - 1] == "brand" || arr[type - 1] == "cube" || arr[type - 1] == "numbers" ? selectFlag = true : selectFlag = false;
                this.setData.configs[arr[type - 1]].forEach(it => {
                    if (item.key == it.key) {
                        it.show = !it.show;
                    }
                    if (selectType) {
                        if (selectType && selectFlag) {
                            if (item.key != it.key) {
                                it.show = false;
                            }
                        } else {
                            if (item.key == it.key) {
                                it.show = true;
                            } else {
                                it.show = false;
                            }
                        }
                    }
                })
                this.setData.tpl = this.target;
                this.setLabel()
            },
            changeComName(val) {
                this.printData.company_name = val;
            },
            checkCompany(item, num) {
                this.setData.configs.company_infos.forEach((em, index) => {
                    if ((item.id && item.id == em.id) || index == num) {
                        em.status = em.status == 0 ? 1 : 0;
                    } else {
                        em.status = 0;
                    }
                })
                // 选中公司
                let isCompany = this.setData.configs.company_infos.some(em => (em.status == 1));
                this.setData.configs.inputs[0].status = isCompany ? 0 : 1;
                this.setLabel();
            },
            sliderChange() {
                this.setLabel();
            },
            setLabel() {
                let params = JSON.parse(JSON.stringify(this.setData));
                params.tpl = this.target;
                // 北美材 默认 欧洲材 字体大小
                if (params.tpl == 0) {
                    localStorage.setItem('defaultSize', this.setData.configs.inputs[2].value);
                } else if (params.tpl == 1) {
                    localStorage.setItem('europeSize', this.setData.configs.inputs[2].value);
                }
                this.postFunc("/erp/print.set.tag.update", params, res => {
                    this.tip("设置成功", "success");
                    // this.printData.config = ","+(res.data.data.configs.join(",")).toString()+","
                    this.getList()
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },
            // 不更新页面 
            setNoUploadLabel() {
                this.postFunc("/erp/print.set.tag.update", this.setData, res => {
                    this.tip("设置成功", "success");
                }, error => {
                    this.tip(error.data.message, "warning")
                })
            },

            addCompany() {
                this.setData.configs.company_infos.push({
                    name: '', address: '', phone: '', logo: '', qr_code: '', status: 0
                })
            },
            deleteCompany(num) {
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((item, index) => {
                        if (index == num) {
                            this.setData.configs.company_infos.splice(index, 1);
                        }
                    })
                }
            },
            // 上传logo
            uploadParams(item, num) {
                this.companyParams = item;
                this.companyNum = num;
            },
            handleSuccess(res) {
                let { companyParams } = this.$data;
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((item, index) => {
                        if ((companyParams.id && item.id == companyParams.id) || this.companyNum == index) {
                            item.logo = res.data.base_url
                        }
                    })
                }
                this.setLabel();
            },
            deleteLogo(em, num) {
                let { companyParams } = this.$data;
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((item, index) => {
                        if (em.id == item.id) {
                            item.logo = ''
                        }
                    })
                }
                this.setLabel();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },

            // 上传微信二维码
            uploadUserQrcodeParams(item, num) {
                this.companyParams = item;
                this.companyNum = num;
            },
            handleQrcodeSuccess(res) {
                let { companyParams } = this.$data;
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((item, index) => {
                        if ((companyParams.id && item.id == companyParams.id) || this.companyNum == index) {
                            item.qr_code = res.data.base_url
                        }
                    })
                }
                this.setLabel();
            },
            deleteQrcode(item, num) {
                let { companyParams } = this.$data;
                if (this.setData.configs.company_infos) {
                    this.setData.configs.company_infos.forEach((em, index) => {
                        if (item.id == em.id) {
                            item.qr_code = ''
                        }
                    })
                }
                this.setLabel();
            },
            beforeQrcodeUpload(file) {
                this.file = file;
                return this.getOss();
            },

            // 上传 oss
            getOss() {
                let self = this;
                return new Promise((resolve, reject) => {
                    window.axios.post(window.oss_url + "/tool/v1/oss.policy.get", {
                        operate_code: "shop-excel"
                    }).then((response) => {
                        if (response.data.code == 0) {
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key: self.oss.dir + "${filename}",
                                policy: self.oss.policy,
                                OSSAccessKeyId: self.oss.accessid,
                                success_action_status: "200",
                                callback: self.oss.callback,
                                signature: self.oss.signature,
                                'Cache-Control': self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(() => {
                        reject();
                    })
                })
            },

            upDataImage(url) {
                this.printData.background_tag = url;
                if (this.setData.configs.qrcode) {
                    this.setData.configs.qrcode.forEach(item => {
                        if (item.key == 'background_tag') {
                            item.value = url;
                        }
                        if (item.key == 'tag_history') {
                            if (item.value && item.value.length > 0) {
                                item.value.push(url);
                            } else {
                                item.value = [url];
                            }
                        }
                    })
                }
                this.setLabel();
            },
            deleteImg(url, ind) {
                this.setData.configs.qrcode[1].value.forEach((item, index) => {
                    if (index == ind) {
                        this.setData.configs.qrcode[1].value.splice(index, 1);
                    }
                })
                this.setLabel();
            },
            checkImage(url) {
                this.printData.background_tag = url;
                this.setData.configs.qrcode.forEach(item => {
                    if (item.key == 'background_tag') {
                        item.value = url;
                    }
                })
                this.setLabel();
            }
        }
    }
</script>